var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _vm.comment && _vm.comment.count > 0 && _vm.availableWechatId ? _c('div', {
    staticClass: "content-section user-evaluation",
    attrs: {
      "id": "component-user-evaluation"
    }
  }, [_c('div', {
    staticClass: "content-title-wrap"
  }, [_c('div', {
    staticClass: "content-section-title"
  }, [_vm._v("用户评价")]), _vm.comment.count > 1 ? _c('div', {
    staticClass: "content-section-more user-evaluation-more",
    on: {
      "click": function click($event) {
        return _vm.goEvaluation();
      }
    }
  }, [_c('span', [_vm._v("全部评价(" + _vm._s(_vm._f("formatScore")(_vm.comment.count)) + "条)")]), _c('ycf-svg', {
    staticClass: "iconfont arrowleft",
    attrs: {
      "icon-name": "arrowleft"
    }
  })], 1) : _vm._e()]), _c('div', {
    staticClass: "content-section-main"
  }, [_c('div', {
    staticClass: "user-evaluation-offset-top"
  }, [_c('div', {
    staticClass: "user-evaluation-offset-top-left"
  }, [_c('div', {
    staticClass: "avatar"
  }, [_c('ycf-image', {
    attrs: {
      "src": _vm.comment.usePic ? _vm.comment.usePic : _vm.defaultAvatar
    }
  })], 1), _c('div', {
    staticClass: "user-evaluation-msg"
  }, [_c('div', {
    staticClass: "user-evaluation-name"
  }, [_vm._v("\n            " + _vm._s(_vm.comment.userName) + "\n          ")]), _c('div', {
    staticClass: "user-evaluation-score"
  }, [_c('ycf-star', {
    attrs: {
      "point": _vm.comment.score * 1
    }
  })], 1)])]), _c('div', {
    staticClass: "user-evaluation-offset-top-right"
  }, [_vm._v("\n        " + _vm._s(_vm._f("formatTime")(_vm.comment.createTime)) + "\n      ")])]), _c('div', {
    staticClass: "user-evaluation-detail"
  }, [_c('span', [_vm._v(_vm._s(_vm.comment.content))])]), _vm.comment.allImgs && _vm.comment.allImgs.length > 0 ? _c('ul', {
    staticClass: "user-evaluation-photo-list"
  }, [_vm._l(_vm.comment.allImgs, function (item, index) {
    return [index < 4 ? _c('li', {
      key: index,
      on: {
        "click": function click($event) {
          return _vm.goEvaluation();
        }
      }
    }, [item.type == 'video' ? _c('img', {
      staticClass: "play-icon",
      attrs: {
        "src": "https://qiniu-cdn7.jinxidao.com/wxProgram/images/zby/play_big_icon.png",
        "alt": ""
      }
    }) : _vm._e(), _c('ycf-image', {
      attrs: {
        "src": item.url
      }
    }), index == 3 && _vm.comment.allImgs.length > 4 ? _c('div', {
      staticClass: "user-evaluation-photo-count"
    }, [_vm._v("\n            共" + _vm._s(_vm.comment.allImgs.length) + "张\n          ")]) : _vm._e()], 1) : _vm._e()];
  })], 2) : _vm._e()])]) : _vm._e();
};
var staticRenderFns = [];
export { render, staticRenderFns };